var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":_vm.getAlertType(_vm.vigenciaCompetencias),"dense":"","color":_vm.getAlertColor(_vm.vigenciaCompetencias)}},[_vm._v(" "+_vm._s(_vm.getAlertText(_vm.vigenciaCompetencias))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }